'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var DeepEqual = require('@hapi/hoek/lib/deepEqual');
var Common = require('./common');
var internals = {};
module.exports = internals.Values = /*#__PURE__*/function () {
  function _class(values, refs) {
    _classCallCheck(this, _class);
    this._values = new Set(values);
    this._refs = new Set(refs);
    this._lowercase = internals.lowercases(values);
    this._override = false;
  }
  _createClass(_class, [{
    key: "add",
    value: function add(value, refs) {
      // Reference

      if (Common.isResolvable(value)) {
        if (!this._refs.has(value)) {
          this._refs.add(value);
          if (refs) {
            // Skipped in a merge
            refs.register(value);
          }
        }
        return;
      }

      // Value

      if (!this.has(value, null, null, false)) {
        this._values.add(value);
        if (typeof value === 'string') {
          this._lowercase.set(value.toLowerCase(), value);
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(value) {
      // Reference

      if (Common.isResolvable(value)) {
        this._refs.delete(value);
        return;
      }

      // Value

      this._values.delete(value);
      if (typeof value === 'string') {
        this._lowercase.delete(value.toLowerCase());
      }
    }
  }, {
    key: "has",
    value: function has(value, state, prefs, insensitive) {
      return !!this.get(value, state, prefs, insensitive);
    }
  }, {
    key: "get",
    value: function get(value, state, prefs, insensitive) {
      if (!this.length) {
        return false;
      }

      // Simple match

      if (this._values.has(value)) {
        return {
          value: value
        };
      }

      // Case insensitive string match

      if (typeof value === 'string' && value && insensitive) {
        var found = this._lowercase.get(value.toLowerCase());
        if (found) {
          return {
            value: found
          };
        }
      }
      if (!this._refs.size && typeof value !== 'object') {
        return false;
      }

      // Objects

      if (typeof value === 'object') {
        var _iterator = _createForOfIteratorHelper(this._values),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (DeepEqual(item, value)) {
              return {
                value: item
              };
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      // References

      if (state) {
        var _iterator2 = _createForOfIteratorHelper(this._refs),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ref = _step2.value;
            var resolved = ref.resolve(value, state, prefs, null, {
              in: true
            });
            if (resolved === undefined) {
              continue;
            }
            var items = !ref.in || typeof resolved !== 'object' ? [resolved] : Array.isArray(resolved) ? resolved : Object.keys(resolved);
            var _iterator3 = _createForOfIteratorHelper(items),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _item = _step3.value;
                if (typeof _item !== typeof value) {
                  continue;
                }
                if (insensitive && value && typeof value === 'string') {
                  if (_item.toLowerCase() === value.toLowerCase()) {
                    return {
                      value: _item,
                      ref: ref
                    };
                  }
                } else {
                  if (DeepEqual(_item, value)) {
                    return {
                      value: _item,
                      ref: ref
                    };
                  }
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return false;
    }
  }, {
    key: "override",
    value: function override() {
      this._override = true;
    }
  }, {
    key: "values",
    value: function values(options) {
      if (options && options.display) {
        var values = [];
        for (var _i = 0, _arr = [].concat(_toConsumableArray(this._values), _toConsumableArray(this._refs)); _i < _arr.length; _i++) {
          var item = _arr[_i];
          if (item !== undefined) {
            values.push(item);
          }
        }
        return values;
      }
      return Array.from([].concat(_toConsumableArray(this._values), _toConsumableArray(this._refs)));
    }
  }, {
    key: "clone",
    value: function clone() {
      var set = new internals.Values(this._values, this._refs);
      set._override = this._override;
      return set;
    }
  }, {
    key: "concat",
    value: function concat(source) {
      Assert(!source._override, 'Cannot concat override set of values');
      var set = new internals.Values([].concat(_toConsumableArray(this._values), _toConsumableArray(source._values)), [].concat(_toConsumableArray(this._refs), _toConsumableArray(source._refs)));
      set._override = this._override;
      return set;
    }
  }, {
    key: "describe",
    value: function describe() {
      var normalized = [];
      if (this._override) {
        normalized.push({
          override: true
        });
      }
      var _iterator4 = _createForOfIteratorHelper(this._values.values()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var value = _step4.value;
          normalized.push(value && typeof value === 'object' ? {
            value: value
          } : value);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var _iterator5 = _createForOfIteratorHelper(this._refs.values()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _value = _step5.value;
          normalized.push(_value.describe());
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return normalized;
    }
  }, {
    key: "length",
    get: function get() {
      return this._values.size + this._refs.size;
    }
  }], [{
    key: "merge",
    value: function merge(target, source, remove) {
      target = target || new internals.Values();
      if (source) {
        if (source._override) {
          return source.clone();
        }
        for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(source._values), _toConsumableArray(source._refs)); _i2 < _arr2.length; _i2++) {
          var item = _arr2[_i2];
          target.add(item);
        }
      }
      if (remove) {
        for (var _i3 = 0, _arr3 = [].concat(_toConsumableArray(remove._values), _toConsumableArray(remove._refs)); _i3 < _arr3.length; _i3++) {
          var _item2 = _arr3[_i3];
          target.remove(_item2);
        }
      }
      return target.length ? target : null;
    }
  }]);
  return _class;
}();
internals.Values.prototype[Common.symbols.values] = true;

// Aliases

internals.Values.prototype.slice = internals.Values.prototype.clone;

// Helpers

internals.lowercases = function (from) {
  var map = new Map();
  if (from) {
    var _iterator6 = _createForOfIteratorHelper(from),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var value = _step6.value;
        if (typeof value === 'string') {
          map.set(value.toLowerCase(), value);
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  return map;
};